import Box from '@mui/material/Box';
import { Outlet, useNavigate } from 'react-router-dom';
import Main from './Main';
import GoToBiggerScreenModal from '../../components/go-to-bigger-screen-modal/GoToBiggerScreenModal';

const Dashboard = ({
  showSidebar = true,
  showChat,
  padding = true,
  bgColor = '#FFF',
}: {
  showSidebar?: boolean;
  showChat?: boolean;
  bgColor?: string;
  padding?: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        paddingBottom: '80px',
        backgroundColor: bgColor,
        minHeight: '100vh',


      }}


    >
      <GoToBiggerScreenModal onClick={() => navigate('/', { replace: true })} />
      <Main showSidebar={showSidebar} 
      
      showChat={showChat} padding={padding} outlet={<Outlet />} />
    </Box>
  );
};

export default Dashboard;
